import React, { useState, useEffect } from "react";
import LoadLog from "./LoadLog";
import DischargeLog from "./DischargeLog";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  alpha,
  useTheme,
} from "@mui/material";
import { useVoyageContextV2 } from "../../Contexts/VoyageContextV2";
import { useTranslation } from "react-i18next";
import { getSelectedCargo, getSelectedTrip } from "../../utils/voyageSelection";
import { getVoyageNumber } from "../../utils/domainSelectors";

const Logging = () => {
  const { t } = useTranslation("logging");
  const theme = useTheme();

  const {
    currentVoyage,
    selectedTripId,
    selectedCargoIndex,
    setSelectedCargoIndex,
  } = useVoyageContextV2();

  const [loading, setLoading] = useState(true);

  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  useEffect(() => {
    if (selectedTrip) {
      if (selectedCargoIndex !== 0) {
        setSelectedCargoIndex(0);
      }
      setLoading(false);
      return;
    }
    setLoading(true);
  }, [selectedTrip, selectedCargoIndex, setSelectedCargoIndex]);

  if (loading || !currentVoyage || !selectedTrip) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  const isOperationLoading = selectedTrip.operationType === "Loading";
  const currentCargoName = selectedCargo?.cargo || "No Cargo";

  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="900">
          {t("title")}
        </Typography>
        <Typography variant="body2" color="primary">
          VOY: {getVoyageNumber(currentVoyage)} | {selectedTrip.to}
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 4,
          borderRadius: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: isOperationLoading
            ? alpha(theme.palette.info.main, 0.1)
            : alpha(theme.palette.warning.main, 0.1),
          border: "1px solid",
          borderColor: isOperationLoading ? "info.light" : "warning.light",
        }}
      >
        <Box>
          <Typography
            variant="overline"
            sx={{
              fontWeight: 900,
              color: isOperationLoading ? "info.main" : "warning.main",
            }}
          >
            {isOperationLoading ? "Loading" : "Discharging"}
          </Typography>
          <Typography variant="h6" fontWeight="800">
            {currentCargoName}
          </Typography>
        </Box>
      </Paper>

      <Box>
        {isOperationLoading ? (
          <LoadLog
            trip={selectedTrip}
            cargoIndex={selectedCargoIndex}
            tripId={selectedTrip.tripId || selectedTripId}
          />
        ) : (
          <DischargeLog
            trip={selectedTrip}
            cargoIndex={selectedCargoIndex}
            tripId={selectedTrip.tripId || selectedTripId}
          />
        )}
      </Box>
    </Box>
  );
};

export default Logging;
